






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import urlHelperService from '@/core/urlHelper.service';
import CategoryNameAndCount from '@/project/search/navigation/CategoryNameAndCount.vue';
import ReadMore from '@/core/ui-components/ReadMore.vue';

@Component({
    components: { CategoryNameAndCount, ReadMore }
})
export default class CategoryFacets extends Vue {
    @Prop({ type: Array, required: true })
    private menuItems!: MenuItem[];

    @Prop({ type: Boolean, default: true })
    private showTitle!: boolean;

    @Prop({ type: Number, default: 10 })
    private minItems!: number;

    private toggle(menuItem: MenuItem) {
        menuItem.selected = !menuItem.selected;
        urlHelperService.setCategoryIds(menuItem.categoryIds, menuItem.selected, false);
    }
}
